
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicePlans",
      function () {
        return require("private-next-pages/servicePlans.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicePlans"])
      });
    }
  